import { useLanguage } from '@/i18n/LanguageContext';
import { cn } from '@/lib/utils';

interface LanguageSwitcherProps {
  className?: string;
}

export default function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { lang, setLanguage } = useLanguage();

  return (
    <div className={cn('flex items-center gap-[2px] rounded-[8px] p-[2px]', className)}>
      <button
        onClick={() => setLanguage('ru')}
        className={cn(
          'rounded-[6px] px-[10px] py-[4px] text-[12px] font-semibold font-manrope transition-colors',
          lang === 'ru'
            ? 'bg-white text-[color:var(--black-text,#0d0d0d)] shadow-sm'
            : 'text-[color:var(--grey-text,#565858)] hover:text-[color:var(--black-text,#0d0d0d)]'
        )}
      >
        РУ
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={cn(
          'rounded-[6px] px-[10px] py-[4px] text-[12px] font-semibold font-manrope transition-colors',
          lang === 'en'
            ? 'bg-white text-[color:var(--black-text,#0d0d0d)] shadow-sm'
            : 'text-[color:var(--grey-text,#565858)] hover:text-[color:var(--black-text,#0d0d0d)]'
        )}
      >
        EN
      </button>
    </div>
  );
}
